import { NewDynamicTab } from "../../../components/Page";
import { ChhattisgarhGenerationDefaultDates } from "../../../config/DefaultDates";
import { CgsTitle } from "../components";
import { TabSwitcher } from "../CGS_Dashboard";
import { BySource } from "./BySource";
import { OperatingPar } from "./OperatingPar";
import RajOutage from "./Outage";
import { CgsGenOverview } from "./Overview";
import { ByPowerStation } from "./PowerStation";
import RajasthanTrend from "./TrendAnalysis";

export function CgsGeneration() {
  return (
    <NewDynamicTab
      hideDateFilterOnTabs={["Operating Parameters"]}
      defaultDates={ChhattisgarhGenerationDefaultDates}
      trendTabs={["Trend Analysis"]}
      header="Generation"
      middleComponent={<CgsTitle />}
      headerPrefixComponent={<TabSwitcher />}
      tabs={{
        Overview: <CgsGenOverview />,
        // "Trend Analysis": <RajasthanTrend />,
        // "By Source": <BySource />,
        // "By Power Station": <ByPowerStation />,
        // Outage: <RajOutage />,
        // "Operating Parameters": <OperatingPar />,
      }}
    />
  );
}
